import { Box, Stack, Typography } from "@mui/material";
import { STEP_TITLES } from "../constants";

const getStepCircleBackgroundColor = (isActive: boolean, isCompleted: boolean) => {
  if (isCompleted) return "#08A56C";
  if (isActive) return "primary.main";

  return "common.white";
};

const getStepTextColor = (isActive: boolean, isCompleted: boolean) => {
  if (isActive) return "#081B3A";
  if (isCompleted) return "#35507E";

  return "#9AAAD1";
};

const CompanyRegisterStepper = ({ currentStep }: { currentStep: number }) => (
  <Stack
    direction='row'
    spacing={{ xs: 2.5, sm: 5.5 }}
    alignItems='center'
    sx={{ mb: 5, flexWrap: "wrap", rowGap: 2 }}>
    {STEP_TITLES.map((title, index) => {
      const stepNumber = index + 1;
      const isActive = currentStep === stepNumber;
      const isCompleted = currentStep > stepNumber;

      return (
        <Stack
          key={title}
          direction='row'
          spacing={1.5}
          alignItems='center'>
          <Box
            sx={{
              width: 38,
              height: 38,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: isActive || isCompleted ? "common.white" : "#9AAAD1",
              backgroundColor: getStepCircleBackgroundColor(isActive, isCompleted),
              border: isCompleted || isActive ? "none" : "1px solid #D5E0FF",
              fontSize: 20,
              fontWeight: 700,
              flexShrink: 0,
            }}>
            {stepNumber}
          </Box>

          <Typography
            sx={{
              color: getStepTextColor(isActive, isCompleted),
              fontSize: { xs: 16, sm: 18 },
              fontWeight: isActive ? 700 : 500,
              lineHeight: 1.2,
            }}>
            {title}
          </Typography>
        </Stack>
      );
    })}
  </Stack>
);

export default CompanyRegisterStepper;
